function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import cx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { childrenUtils, customPropTypes, getComponentType, getUnhandledProps, getKeyOnly } from '../lib';

/**
 * A divider visually segments content into groups.
 */
var Divider = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    clearing = props.clearing,
    content = props.content,
    fitted = props.fitted,
    hidden = props.hidden,
    horizontal = props.horizontal,
    inverted = props.inverted,
    section = props.section,
    vertical = props.vertical;
  var classes = cx('ui', getKeyOnly(clearing, 'clearing'), getKeyOnly(fitted, 'fitted'), getKeyOnly(hidden, 'hidden'), getKeyOnly(horizontal, 'horizontal'), getKeyOnly(inverted, 'inverted'), getKeyOnly(section, 'section'), getKeyOnly(vertical, 'vertical'), 'divider', className);
  var rest = getUnhandledProps(Divider, props);
  var ElementType = getComponentType(props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes,
    ref: ref
  }), childrenUtils.isNil(children) ? content : children);
});
Divider.displayName = 'Divider';
Divider.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** Divider can clear the content above it. */
  clearing: PropTypes.bool,
  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,
  /** Divider can be fitted without any space above or below it. */
  fitted: PropTypes.bool,
  /** Divider can divide content without creating a dividing line. */
  hidden: PropTypes.bool,
  /** Divider can segment content horizontally. */
  horizontal: PropTypes.bool,
  /** Divider can have its colours inverted. */
  inverted: PropTypes.bool,
  /** Divider can provide greater margins to divide sections of content. */
  section: PropTypes.bool,
  /** Divider can segment content vertically. */
  vertical: PropTypes.bool
};
export default Divider;
//# sourceMappingURL=Divider.js.map